import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { default as Scheme$62fb } from '/build/schemes/customStrategy.js'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": false,
    "logout": false,
    "home": false,
    "callback": false
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": false,
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "local"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // local
  $auth.registerStrategy('local', new Scheme$62fb($auth, {
  "token": {
    "required": false,
    "type": false,
    "maxAge": 0
  },
  "endpoints": {
    "login": {
      "url": "/rest/v1/auth/session",
      "method": "POST"
    },
    "user": {
      "url": "/jsonapi/account/me?include=membership,membership.package,membership.lastDiscount,profile,profile.schoolLevel,fset,profile.careerGoal,profile.militaryAffiliation,profile.ethnicity,profile.country,profile.citizenship,profile.degree,profile.degreeType,profile.recurringApplication,profile.state,profile.studyCountry1,profile.studyCountry2,profile.studyCountry3,profile.studyCountry4,profile.studyCountry5&meta=srv,affid,scholarshipStat,countryCodeByIp,membership.maintenanceMode,membership.lastDiscount.expiresAt,membership.trialReferralExtensionGrantedAt,membershipStatus,mailbox",
      "method": "GET"
    }
  },
  "user": {
    "property": "data"
  },
  "name": "local"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
